import {filter, find, isNil, map} from 'lodash'

export const convertListToTree = (data, rootId = null, parentLabel, idProp = 'id', parentIdProp = 'parentId', childrenProperty = 'children') => {
  let root = find(data,[idProp, rootId])
  const children = filter(data, [parentIdProp, rootId])
  if (isNil(root)) {
    root = {}
    root['label'] = parentLabel
    root[idProp] = rootId
    root[childrenProperty] = []
  }
  // find the children and recurse
  const childs = map(children, item => {
    return convertListToTree(data, item[idProp], parentLabel, idProp, parentIdProp, childrenProperty)
  })
  root[childrenProperty] = childs
  return root
}

export const deleteFromTreeList = (data, deleteId, idProp = 'id', parentIdProp = 'parentId') => {
  let ret = [ ...data ]

  // Remove all sub-nodes
  ret.forEach(n => {
    if (n[parentIdProp] === deleteId) ret = deleteFromTreeList(ret, n[idProp], idProp, parentIdProp)
  })

  // Remove the specified node
  return ret.filter(n => n[idProp] !== deleteId)
}

// Traverses the tree branches and returns all leaves from the specified branch downward
export const getAllLeavesForBranch = (leaves, branches, parentId, leafParentIdProp = 'parentId', branchIdProp = 'id', branchParentIdProp = 'parentId') => {
  let ret = leaves.filter(l => l[leafParentIdProp] === parentId)
  branches
    .filter(b => b[branchParentIdProp] === parentId)
    .forEach(n => {
      ret = [
        ...ret,
        ...getAllLeavesForBranch(leaves, branches, n[branchIdProp], leafParentIdProp, branchIdProp, branchParentIdProp),
      ]
    })

  return ret
}

// Traverses the tree branches and returns all branches from the specified branch downard
export const getAllBranchesForBranch = (branches, parentId, branchIdProp = 'id', branchParentIdProp = 'parentId') => {
  let ret = []
  branches.forEach(n => {
    if (n[branchParentIdProp] === parentId) {
      ret = [
        ...ret,
        n,
        ...getAllBranchesForBranch(branches, n[branchIdProp], branchIdProp, branchParentIdProp),
      ]
    }
  })
  return ret
}

export const getDifferenceKeys = (object1, object2) =>
  Object.keys(object1).filter(key => object1[key] !== object2[key])

export const mergeObjectForKeys = (object, mergeObject, mergeKeys) => {
  const ret = {...object}
  mergeKeys.forEach(key => ret[key] = mergeObject[key])
  return ret
}

export default {
  convertListToTree,
  deleteFromTreeList,
  getAllLeavesForBranch,
  getAllBranchesForBranch,
}
